import { useContext } from "react";
import FilterButton from "../DndTable/TableFilterV2/FilterView/FilterButton"
import Modal from "src/components/Common/UI/Modal/Modal";
import { SydFilterContext } from "./SydFilterContext";

const SydFilterView = ({title, children}: SydFilterViewProps) => {
  const sydFilterCtx = useContext(SydFilterContext);

  const toggleVisibility = sydFilterCtx.toggleFilterVisibility;
  const isFilterVisible = sydFilterCtx.isFilterVisible;
  const isFilterActive = sydFilterCtx.checkFilterIsActive();

  const FilterViewButton: React.FC = () => {
    return (
      <FilterButton 
          onClick={toggleVisibility} 
          isActive={isFilterActive}
          isRightBarOpen={false}
        />
      )
  }

  return (
    <>
      <FilterViewButton />
      <Modal
        isOpen={isFilterVisible}
        closeFilterModal={toggleVisibility}
        title={title}
        hasOverflow={false}  
      >
          {children}
      </Modal>
    </>
  )
}

export default SydFilterView;

interface SydFilterViewProps {
  title: string;
  children: JSX.Element;
}